/**
 * HOC para busca de resultados baseados em UIDs
 */
import withUIDQueryResults from './withUIDQueryResults';

export default withUIDQueryResults;

export * from './utils';
